// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Role_account-table-role-list__5Vail .Role_green__zqk49 {
  border-radius: 3px;
  border: 1px solid var(--institution-role);
  width: fit-content;
  padding: 3px 10px;
  max-width: 300px;
  margin-bottom: 5px;
}
.Role_account-table-role-list__5Vail .Role_green__zqk49 .Role_type__2ejiT {
  color: var(--institution-role);
  font-weight: bold;
}
.Role_account-table-role-list__5Vail .Role_green__zqk49 .Role_institution__SGQmf {
  font-weight: 600;
}
.Role_account-table-role-list__5Vail .Role_green__zqk49 .Role_permission__-wRHw {
  font-size: 10px;
}
.Role_account-table-role-list__5Vail .Role_gold__FAp\\+1 {
  border-radius: 3px;
  border: 1px solid var(--personal-role);
  width: fit-content;
  padding: 3px 10px;
  max-width: 300px;
  margin-bottom: 5px;
  color: var(--personal-role);
  font-weight: 600;
}
.Role_account-table-role-list__5Vail .Role_purple__gEFIZ {
  border-radius: 3px;
  border: 1px solid var(--unit-role);
  width: fit-content;
  padding: 3px 10px;
  max-width: 300px;
  margin-bottom: 5px;
}
.Role_account-table-role-list__5Vail .Role_purple__gEFIZ .Role_type__2ejiT {
  color: var(--unit-role);
  font-weight: bold;
}
.Role_account-table-role-list__5Vail .Role_purple__gEFIZ .Role_institution__SGQmf {
  font-weight: 600;
}
.Role_account-table-role-list__5Vail .Role_purple__gEFIZ .Role_permission__-wRHw {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountList/Components/Role/Role.module.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AACI;EACE,8BAAA;EACA,iBAAA;AACN;AACI;EACE,gBAAA;AACN;AACI;EACE,eAAA;AACN;AAEE;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AACI;EACE,uBAAA;EACA,iBAAA;AACN;AACI;EACE,gBAAA;AACN;AACI;EACE,eAAA;AACN","sourcesContent":[".account-table-role-list {\n  .green {\n    border-radius: 3px;\n    border: 1px solid var(--institution-role);\n    width: fit-content;\n    padding: 3px 10px;\n    max-width: 300px;\n    margin-bottom: 5px;\n    .type {\n      color: var(--institution-role);\n      font-weight: bold;\n    }\n    .institution {\n      font-weight: 600;\n    }\n    .permission {\n      font-size: 10px;\n    }\n  }\n  .gold {\n    border-radius: 3px;\n    border: 1px solid var(--personal-role);\n    width: fit-content;\n    padding: 3px 10px;\n    max-width: 300px;\n    margin-bottom: 5px;\n    color: var(--personal-role);\n    font-weight: 600;\n  }\n  .purple {\n    border-radius: 3px;\n    border: 1px solid var(--unit-role);\n    width: fit-content;\n    padding: 3px 10px;\n    max-width: 300px;\n    margin-bottom: 5px;\n    .type {\n      color: var(--unit-role);\n      font-weight: bold;\n    }\n    .institution {\n      font-weight: 600;\n    }\n    .permission {\n      font-size: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account-table-role-list": `Role_account-table-role-list__5Vail`,
	"green": `Role_green__zqk49`,
	"type": `Role_type__2ejiT`,
	"institution": `Role_institution__SGQmf`,
	"permission": `Role_permission__-wRHw`,
	"gold": `Role_gold__FAp+1`,
	"purple": `Role_purple__gEFIZ`
};
export default ___CSS_LOADER_EXPORT___;
